import {
	ControllerRenderProps,
	FieldError,
	FieldErrorsImpl,
	FieldValues,
	Merge,
} from 'react-hook-form';

import React from 'react';
import { useTranslation } from 'react-i18next';

interface CardInputProps {
	field?: ControllerRenderProps<FieldValues, any>;
	children?: React.ReactNode;
	title?: string;
	subTitle: string;
	caption?: string;
	legal: string;
	isLoading: boolean;
	errorMessage?: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
}

function CardInput({
	field,
	children,
	title,
	subTitle,
	caption,
	legal,
	isLoading,
	errorMessage,
}: CardInputProps) {
	const { t } = useTranslation();
	return (
		<div className='card-input'>
			<div className='card-input__body'>
				<div className='card-input__header'>
					{title && <h5>{title}</h5>}
					<p>{subTitle}</p>
					<p>{caption}</p>
				</div>
				{children ? (
					children
				) : (
					<div className='card-input__body__input__wrapper'>
						<input
							data-test-id='card-input-input'
							id={field!.name}
							{...field}
							className='card-input__body__input'
							type='text'
							autoComplete='on'
						/>
						<button
							type='submit'
							data-test-id='card-input-btn-submit'
							className='card-input__body__input__icon'
							disabled={isLoading}
						>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								fill='none'
								viewBox='0 0 24 24'
								strokeWidth='1.5'
								stroke='currentColor'
								className='icon'
							>
								<path
									strokeLinecap='round'
									strokeLinejoin='round'
									d='M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3'
								/>
							</svg>
						</button>
					</div>
				)}{' '}
				{errorMessage && (
					<span data-test-id='card-input-error' className='input__error'>
						<p className='arrow-container mb-4'>
							<span className='up-arrow'></span>
						</p>
						<div className='input__error__block'>{errorMessage as string}</div>
					</span>
				)}
				<div className='card-input__legal'>
					<span>{legal}</span>
					<a
						href={t('confirm-index.register.legal.url')}
						rel='noreferrer'
						target='_blank'
					>
						{' '}
						{t('confirm-index.register.legal.link')}
					</a>
				</div>
			</div>
		</div>
	);
}

export default CardInput;
